import TablePager from './table-pager'

export default TablePager